import React from "react";
import Mission from "../../Assets/About/MissionImage.png";
import Vision from "../../Assets/About/VisionImage.png";

function VisionMission() {
  return (
    <div className="mx-6 md:mx-16 my-6 md:my-16 ">
      <div className="flex flex-col md:flex-row text-center items-center justify-center mb-16 md:mb-8">
        <div
          className="w-full md:w-[50%] flex flex-col items-center p-4 xl:px-24"
          style={{ fontFamily: "Poppins, sans-serif" }}
          data-aos="fade-right"
        >
          <h1 className="text-xl text-[#FBA710] font-semibold text-center flex flex-col mb-4">
            VISION
          </h1>
          <hr className="border-t-2 border-[#FBA710] w-[70%] mb-2" />
          <hr className="border-t-2 border-[#FBA710] w-[70%] mb-4" />
          <p className="mt-4 text-base opacity-70 tracking-wide capitalize">
            At GoCabz, our vision is to be the most trusted and preferred cab
            service provider in Bhubaneswar by prioritizing safety first and
            ensuring complete customer comfort on every journey. We strive to
            deliver transparent pricing, reliable service, and a seamless travel
            experience while maintaining the highest standards of
            professionalism and trust. Our commitment is to make every ride
            convenient, secure, and enjoyable, establishing GoCabz as the
            benchmark for excellence in transportation services across Odisha.
          </p>
        </div>
        <img
          src={Vision}
          alt=""
          className="w-full md:w-[50%]"
          data-aos="fade-down"
        />
      </div>

      <div className="flex flex-col md:flex-row text-center items-center justify-center">
        <img
          src={Mission}
          alt=""
          className="w-full md:w-[50%]"
          data-aos="fade-down"
        />
        <div
          className="w-full md:w-[50%] flex flex-col items-center p-4 xl:px-24"
          style={{ fontFamily: "Poppins, sans-serif" }}
          data-aos="fade-left"
        >
          <h1 className="text-xl text-[#FBA710] font-semibold text-center flex flex-col mb-4">
            MISSION
          </h1>
          <hr className="border-t-2 border-[#FBA710] w-[70%] mb-2" />
          <hr className="border-t-2 border-[#FBA710] w-[70%] mb-4" />
          <p className="mt-4 text-base opacity-70 tracking-wide capitalize">
            At GoCabz, our goal is to provide safe, fast, and affordable cab
            services across Bhubaneswar while delivering an exceptional travel
            experience tailored to every passenger’s needs. We are committed to
            ensuring safety, comfort, and convenience on every journey, with
            professional drivers, well-maintained vehicles, and 24/7
            availability. By maintaining the highest standards of service and
            reliability, we strive to be the preferred choice for both locals
            and tourists in Odisha, making every ride seamless, enjoyable, and
            stress-free.
          </p>
        </div>
      </div>
    </div>
  );
}

export default VisionMission;
